define('viewmodels/app/analytics/__settings',[],
    function() {
        'use strict';
        var GRAPHS = {
            GLOBAL: {
                messages: {
                    zeroData: 'Data for Customers is not available.',
                    errorInApiCall:'Failed to fetch data for the chart.',
                    noChartToDisplay: 'There is no data to display since all legends are disabled.'
                },
                FONT_FAMILY: 'MyWebFont',
                DEFAULT_DURATION_DAYS: 'month',
                COLORS: {
                    MOJO_BLUE: '#78a5c8',
                    MOJO_DARK_GREY: '#41414b',
                    MOJO_BLACK: '#0a0a0f',
                    MOJO_WHITE: '#ffffff',
                    MOJO_GREY: '#bebec3',
                    MOJO_LIGHT_GREY: '#e6e6eb',
                    MOJO_OFF_WHITE: '#f5f5fa',
                    MOJO_TEAL: '#32e6f5',
                    MOJO_RED: '#e6465a',
                    MOJO_PURPLE: '#5a46b4',
                    CHART_BLUE: '#41b6c4',
                    CHART_RED: '#ec6c50',
                    CHART_GREEN: '#74c476',
                    CHART_MAROON: '#ce6064',
                    CHART_BROWN: '#A0522D',
                    RANGE6: '#668bcf',
                    RANGE7: '#858282',
                    RANGE8: '#8c83d4',
                    RANGE9: '#f48e57',
                    RANGE10: '#b837ba',
                    RANGE11: '#ed4978',
                    MALE: '#41b6c4',
                    FEMALE: '#ec6c50',
                    UNSPECIFIED: '#858282',
                    BELOW15: '#668bcf',
                    BETWEEN15_24: '#ec6c50',
                    BETWEEN25_34: '#74c476',
                    BETWEEN35_44: '#41b6c4',
                    BETWEEN45_54: '#f48e57',
                    BETWEEN55_64: '#ce6064',
                    ABOVE64: '#8c83d4',
                    YAXIS_TEXT: '#4d759e'
                },
                CHART_MARGINS: {
                    TOP: 30,
                    BOTTOM: 100
                },
                CHART_FONT_SIZE: {
                    AXIS_LABEL: '10px',
                    AXIS_TITLE: '12px'
                },
                FILTERS: {
                    DURATION: {
                        name: '',
                        units: 'Days'
                    },
                    INTERVAL: {
                        name: 'Range: ',
                        units: ''
                    },
                    TYPE: {
                        name: '',
                        units: ''
                    }
                },
                DURATION_DAYS: [{
                    id: 'week',
                    text: '7 Days'
                }, {
                    id: 'month',
                    text: '30 Days'
                }, {
                    id: 'quarter',
                    text: '12 weeks'
                }, {
                    id: 'year',
                    text: '12 months'
                }, {
                    id: 'thisMonth',
                    text: 'This Month'
                }],
                DURATION_ALL_VALUE: 'latest',
                DURATION_LAST_DAY_VALUE: 'day',
                MAX_XAXIS_LABELS:16,
                GRANULARITY_ALL: 'all',
                DURATION_ALL: {
                    id: 'latest',
                    text: 'Latest'
                },
                DURATION_LAST_DAY: {
                    id: 'day',
                    text: 'Last Day'
                },
                LOCATION_POINTS_RESOLUTION: {
                    MAJOR: 10,
                    MINOR: 10
                },
                DEVICE_POINTS_RESOLUTION: {
                    MAJOR: 10,
                    MINOR: 10
                },
                PORTAL_POINTS_RESOLUTION: {
                    MAJOR: 5,
                    MINOR: 5
                },
                PLUGIN_POINTS_RESOLUTION: {
                    MAJOR: 1,
                    MINOR: 15
                },
                LOCATION_INTERVALS: [{
                    min: 0,
                    max: 100
                }, {
                    min: 100,
                    max: 1000
                }, {
                    min: 1000,
                    max: 10000
                }, {
                    min: 10000,
                    max: 100000
                }],
                DEVICE_INTERVALS: [{
                    min: 0,
                    max: 100
                }, {
                    min: 100,
                    max: 1000
                }, {
                    min: 1000,
                    max: 10000
                }, {
                    min: 10000,
                    max: 100000
                }],
                PORTAL_INTERVALS: [{
                    min: 0,
                    max: 25
                }, {
                    min: 25,
                    max: 50
                }, {
                    min: 50,
                    max: 100
                }],
                PLUGIN_INTERVALS: [{
                    min: 0,
                    max: null
                }]
            },
            /**
             * [CHART_METADATA The chart metadata; titles,axis names and colors for the charts.]
             * @type {Object}
             */
            CHART_METADATA: {
                CUSTOMERS_BY_DURATION:{
                    YAXIS_TEXT: 'No. of Customers',
                    TITLE: 'Customer Trend',
                    TOOLTIP: 'The chart shows the total number of customers in the system on a given day/week/month ' +
                        'based on the specified duration. <br /> <br />When the duration specified is 12 weeks or 12 months, the chart shows the average number of customers for ' +
                        'a week or for a month respectively.'
                },
                DEVICES_BY_DURATION: {
                    YAXIS_TEXT: 'No. of Access Points',
                    TITLE: 'Total Access Points',
                    TOOLTIP: 'The chart shows the total number of active Access Points and inactive Access Points in '+ 
                        'the system on a given day/week/month based on the specified duration. ' +
                        '<br /><br />When the duration specified is 12 weeks or 12 months, the chart shows the average number of active/inactive Access Points for a week or ' +
                        'for a month respectively.'
                },
                NEW_CUSTOMERS_VS_DURATION: {
                    YAXIS_TEXT: 'No. of Customers',
                    TITLE: 'New Customers',
                    TOOLTIP: 'The chart shows the number of new customers created in the system on a given '+
                        'day/week/month based on the specified duration.'
                },
                NEW_DEVICES_BY_DURATION: {
                    YAXIS_TEXT: 'No. of Access Points',
                    TITLE: 'New Access Points',
                    TOOLTIP: 'The chart shows the number of new active and inactive Access Points in the system '+
                        'on a given day/week/month based on the specified duration.<br /><br /> The Access Point must connect to '+
                        'the cloud at least once to be included in this chart.<br /><br /> For weekly and monthly data, an Access Point '+
                        'is accounted for only once and not for each day of the week or month for which it was active/inactive.'
                },
                GUEST_CORPORATE_DATA_DURATION: {
                    YAXIS_TEXT: 'Data Usage',
                    TITLE: 'Guest vs Corporate Data Usage',
                    TOOLTIP: 'The chart shows the total data usage (transmitted and received) by clients over Guest and '+
                        'Corporate SSIDs on a given day/week/month based on the specified duration.'
                },
                TOP_CUSTOMERS_USING_DATA: {
                    YAXIS_TEXT: 'Data usage',
                    TITLE: 'Top 5 Customers by Data Usage',
                    TOOLTIP: 'The chart shows the top five customers based on total data usage (transmitted and received) '+
                        'over Guest and Corporate SSIDs on a given day/week/month based on the specified duration.<br /><br /> The chart '+
                        'shows the data usage values for Guest, Corporate, and Total.'
                },
                FEATURE_USAGE_BY_DURATION:{
                    YAXIS_TEXT: 'No of SSIDs',
                    TITLE: 'Feature Usage Trend',
                    TOOLTIP: 'The chart shows, for each feature, the total number of SSIDs that have the feature configured on '+
                        'a given day/week/month based on the specified duration. The chart considers all SSIDs that were applied on '+
                        'any device template.<br /><br /> When the duration specified is 12 weeks or 12 months, '+
                        'the chart shows the average number of SSIDs for a week or for a month respectively.'
                },
                FEATURES_BY_CUSTOMERS: {
                    YAXIS_TEXT: 'No. of Customers',
                    TITLE: 'Feature Usage by Customers',
                    TOOLTIP: 'The chart shows, for each feature, the total number of customers that have configured the feature '+
                        'in any of their SSIDs.'
                },
                PLUGIN_USAGE_BY_DURATION: {
                    YAXIS_TEXT: 'No. of Active Portals',
                    TITLE: 'Plugin Configuration Trend',
                    TOOLTIP: 'The chart shows, for each plugin, the total number of active portals that have the plugin configured '+
                        'on a given day/week/month based on the specified duration.<br /><br /> When the duration specified is 12 weeks or 12 months, '+
                        'the chart shows the average number of active portals for a week or for a month  respectively.'
                },
                CUSTOMERS_BY_PLUGINS: {
                    TITLE: 'Plugin Usage by Customers',
                    YAXIS_TEXT: 'No. of Customers',
                    TOOLTIP: 'The chart shows, for each plugin, the total number of customers that have configured the plugin in '+
                        'any of their active portals.'
                },                
                CUSTOMER_SSID_COUNT: {
                    TITLE: 'Customers by SSID Count',
                    BUCKETS: [0,1,2,3,4],
                    TOOLTIP: 'The pie chart shows the customer distribution based on the number of SSIDs they have used. The '+
                        'chart only considers SSIDs that have been applied on a device template.'
                },
                CUSTOMER_SSID_PROFILE: {
                    TITLE: 'Customers by Network Type',
                    TOOLTIP: 'The pie chart shows the percentage and number of customers who have used no SSIDs, only Guest SSIDs,'+
                        ' only Corporate SSIDs, and both Guest and Corporate SSIDs. The chart only considers SSIDs that have been '+
                        'applied on a device template.'
                },
                CUSTOMER_LOCATIONS: {
                    TITLE: 'Customers by Sites',
                    YAXIS_TEXT: 'No. of Customers',
                    XAXIS_TEXT: 'No. of Sites',
                    TOOLTIP: 'The chart shows the total number of customers based on the number of sites they have access for '+
                        'the selected site range. The chart considers only the leaf nodes (folder) of the location tree.'
                },
                CUSTOMER_DEVICES: {
                    TITLE: 'Customers by Access Points',
                    YAXIS_TEXT: 'No. of Customers',
                    XAXIS_TEXT: 'No. of Access Points',
                    TOOLTIP: 'The chart shows the total number of customers based on the number of managed Access Points they have for '+
                        'the selected Access Point range.'
                },
                CUSTOMER_PORTALS: {
                    TITLE: 'Customers by Portal Count',
                    YAXIS_TEXT: 'No. of Customers',
                    XAXIS_TEXT: 'No. of Portals',
                    TOOLTIP: 'The chart shows the total number of customers based on the number of active portals they have created '+
                        'for the selected portal range.'
                },
                CUSTOMER_PLUGINS: {
                    TITLE: 'Customers by Plugin Count',
                    YAXIS_TEXT: 'No. of Customers',
                    XAXIS_TEXT: 'No. of Plugins',
                    TOOLTIP: 'The chart shows the total number of customers based on the number of plugins they have configured.'
                },
                AUTHENTICATION_NO_DATA_MESSAGE: 'There is no Customer Data'
            }
        };

        var defaultSettings = {
            exporting: {
                enabled: false
            }
        };

        return {
            GRAPHS: GRAPHS,
            defaultSettings: defaultSettings,
            dropdownTemplate: '<span title="#: text #">#: text #</span>'
        };

    });
